webpackJsonp([227772203984691],{

/***/ 527:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAoCAYAAADt5povAAAEkUlEQVRYCbVYXWhcRRQ+Z3Y3NZXWByUmppaCoAUfhGaDNr5ICz4otFURrAiC2SZxVxT64i/a0KcqiMhmQ8wuImgFxWgLNlVQH7RWSdL6Q8FCEcG2xoqmEdrEbnbG72x2knvnzv6iF8LM+c4533dn5szM3TDVeXoGxhLcpu4kQ/cQqa1EppOYu8gYg9RZIsafPk5MR8wVfWzmjcFiLUqu5tzw4Kvt13dc87giehpkHdXiQrihC5rowO8X5kfPvr93IeSrGF7BnnThbsX0FoQ6fUl1MUOz2tCjM7n+T91YDCD8JNOFl1iZyZbFhA4vKhzCFWYnigWB3kx+Pyt+kbFIQbyVvnCA5a7u3h3x81OHv7AcK8Q9mXxKMY9bh9uiRL5GcRzEVH1+aVGdFf/aRPHGWCy+DdyPgPx2N8fa2pg9MyOpvNhlwduGRrsT8bbTMK62QbaF0K9IGDiRSx21mK9NPlHYwYbGfEuBcr5UIrr5ZLb/fHkN22LxAz4xbIFvTHFpSz0xeYHpbP9hjVhsl+/cFxLuuNEvC863pkc629Wac5jzUAFhm51eWKS+U4XUXy5BLbvC9y34NgbjDBm9oP/pVu3c9kBUTLZ1KdWsmAicymVmqaSHgmLSFw3RUmjvdZ3wHp3JDX4VwRsEpkcHJpeLzEmAlsJYNjkwls68G8GaBvTBSAq0cKDwBtexZPSPLtasrTX94OaIVqhQbACzmrP9Vltl2MuhsEd+iZLyDVGsOcSoKIdo4UXMly6VMrrPxZq1sfdwlYUf0VLG6MkwjFtP8W4Xa9JmUvSQmyNaiovmE1yuf4ad3JPMjO8MY41bW9KFhzHCzaEMaIiWkhsaZ+XbIScMvOJrmzPZa128no0vhC6lzCtunGiIVrlKsZhZbFQ0gYdp0zpuf09u/gBas3vLY4V1qi02gfLvCgYKt2gIVhbE4XyG2BwKBlX627o61n8m56PHF4Iwso3r1xIKkO8IOcQAd1kD3bh1Lmk9HOfYTtxrmP7Aw7y1ndb8hDXdZ4r6TUzLfMBLELqOE/EBZD0H3He9GRwkwzYnRN6bKUwg8T7rjLSGFnHuHUPMz5ijGC7emzBZfbjaE5FYCxj6cGqk/35rroxQgKWl4nAsntgVGaWNZroK87Md5nbELD8rHRu02sralcC5ilTW0AInx4a+xwgmrP0ftB8sc64yRc5SfLM8g4q6shrSWk84sBWedbMjglJNRpvX3cBmbeGwlRnMjQiKc37+8n684R/BwGb6kiscvhyv4Jl3nvybSb/gS2gEk1zh8MV6BSVwKnsujyo74UuqhUmO5FaLqSpItE+XmAZR2fh90tgjsZIjudUyaggS4cN1Gom5askePFfJ8biWoZqCEnJx7vLzePPfqjJUHBIjsfXi6grK4qPqnqpHJDHVCiWYaw+oIObtJzP5j3Bmei9lfDUfmh5J7fImOmDdEdr4EnMao7hobdsKJj5r12sbFpRfPthfe11CwcTn4tXshqfUEmBqP8bU4h8M8oFujmAqoz8VbLCnbXiENhfTtwdKc/JX7lvH/9km0+O75a8VjX8B92C5L10nhu0AAAAASUVORK5CYII="

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _mapIcon = __webpack_require__(527);
	
	var _mapIcon2 = _interopRequireDefault(_mapIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contacto = function (_React$Component) {
	    _inherits(Contacto, _React$Component);
	
	    function Contacto() {
	        _classCallCheck(this, Contacto);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Contacto.prototype.componentDidMount = function componentDidMount() {
	        setTimeout(function () {
	            try {
	                // Google maps
	                var mapLocation = new google.maps.LatLng(28.471811, -16.433345);
	
	                var map = new GMaps({
	                    streetViewControl: false,
	                    overviewMapControl: false,
	                    mapTypeControl: false,
	                    panControl: false,
	                    scrollwheel: true,
	                    center: mapLocation,
	                    el: '#map',
	                    zoom: 15,
	                    styles: [{
	                        "featureType": "landscape",
	                        "stylers": [{ "saturation": -100 }, { "lightness": 65 }, { "visibility": "on" }]
	                    }, {
	                        "featureType": "poi",
	                        "stylers": [{ "saturation": -100 }, { "lightness": 51 }, { "visibility": "simplified" }]
	                    }, {
	                        "featureType": "road.highway",
	                        "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }]
	                    }, {
	                        "featureType": "road.arterial",
	                        "stylers": [{ "saturation": -100 }, { "lightness": 30 }, { "visibility": "on" }]
	                    }, {
	                        "featureType": "road.local",
	                        "stylers": [{ "saturation": -100 }, { "lightness": 40 }, { "visibility": "on" }]
	                    }, {
	                        "featureType": "transit",
	                        "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }]
	                    }, {
	                        "featureType": "administrative.province",
	                        "stylers": [{ "visibility": "off" }]
	                    }, {
	                        "featureType": "water",
	                        "elementType": "labels",
	                        "stylers": [{ "visibility": "on" }, { "lightness": -25 }, { "saturation": -100 }]
	                    }]
	                });
	
	                map.addMarker({
	                    position: mapLocation,
	                    icon: _mapIcon2.default
	                });
	            } catch (e) {}
	        }, 500);
	    };
	
	    Contacto.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { style: { marginBottom: '-120px' } },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Contacto'
	                ),
	                _react2.default.createElement('script', { type: 'text/javascript', src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDlYNNs7VBO71qiKFMNiD0R9sd8hOt0wD4' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'contact-us-map' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'location' },
	                        _react2.default.createElement(
	                            'h5',
	                            null,
	                            'Dismocan'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Carretera local, 166. El Sauzal'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '695 54 74 36'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'info@dismocan.com'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-primary d-none d-sm-inline', href: 'https://www.google.com/maps?ll=28.471811,-16.433345&z=15&t=m&hl=en&gl=US&mapclient=apiv3' },
	                            'Ver en google maps'
	                        )
	                    )
	                ),
	                _react2.default.createElement('div', { id: 'map', style: { 'height': 'calc(100vh - 91px - 73px)' } })
	            )
	        );
	    };
	
	    return Contacto;
	}(_react2.default.Component);
	
	exports.default = Contacto;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contacto-js-0c560e926fb02f61495e.js